import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import ClientManagement from "./pages/Client-Management/ClientManagement";
import AddClient from "./pages/Client-Management/AddClient";
import ViewClient from "./pages/Client-Management/ViewClient";
import AddSubClient from "./pages/Client-Management/AddSubClient";
import EditSubClient from "./pages/Client-Management/editSubClient";
import EditClient from "./pages/Client-Management/EditClient";
import TaskManagement from "./pages/TasksManagement/TaskManagement";
import AddTaskClient from "./pages/TasksManagement/AddTaskClient";
import CreateTask from "./pages/TasksManagement/CreateTask";
import Calendar from "./pages/Calendar/Calendar";
import AddCalendarEvent from "./pages/Calendar/AddCalendarEvent";
import Notifications from "./pages/Notifications/Notifications";
import CreateNotification from "./pages/Notifications/CreateNotification";
import CreateAlert from "./pages/Notifications/CreateAlert";
import ViewSubClient from "./pages/Client-Management/ViewSubClient";
import AddEmployee from "./pages/TeamManagement/AddEmployee";
import ViewEmployee from "./pages/TeamManagement/ViewEmployee";
import EditEmployee from "./pages/TeamManagement/EditEmployee";
import ViewClientTask from "./pages/TasksManagement/ViewClientTask";
import NotFoundPage from "./pages/404error/NotFoundPage";
import EditCalendarEvent from "./pages/Calendar/EditCalendarEvent";
import EditNotification from "./pages/Notifications/EditNotification";
import ViewTask from "./pages/TasksManagement/ViewTask";
import TeamManagement from "./pages/TeamManagement/TeamManagement";
import MemberTask from "./pages/TeamManagement/MemberTask";
// import CreateTeamMember from "./pages/TeamManagement/CreateTeamMember";
import ServiceManagement from "./pages/ServicesManagement/ServiceManagement";
import AddService from "./pages/ServicesManagement/AddService";
import ViewService from "./pages/ServicesManagement/components/ViewServices";

import Mail from "./pages/mail/Mail";
import MailDetailsWrapper from "./pages/mail/MailDetailsWrapper";
import Reports from "./pages/reports/Reports";
import ClientReport from "./pages/reports/ClientReport";
import ViewReportTaskPage from "./pages/reports/ViewReportTaskPage";
import Settings from "./pages/settings/Settings";
import Information from "./pages/Information/Information";
import CompliancesAndEvents from "./pages/CompliancesAndEvents/CompliancesAndEvents";
import Enquires from "./pages/Enquires/Enquires";
import AddEnquires from "./pages/Enquires/AddEnquires";
import ViewEnquires from "./pages/Enquires/ViewEnquires";


const routes = [
  { path: "/", element: <Login />, isProtected: false },
  { path: "/dashboard", element: <Dashboard />, isProtected: true },
  {
    path: "/dashboard/view-client/:id",
    element: <ViewClient />,
    isProtected: true,
  },

  // Client Management
  {
    path: "/client-management",
    element: <ClientManagement />,
    isProtected: true,
  },
  {
    path: "/client-management/add-client",
    element: <AddClient />,
    isProtected: true,
  },
  {
    path: "/client-management/edit-client/:id",
    element: <EditClient />,
    isProtected: true,
  },
  {
    path: "/client-management/add-subclient/:id",
    element: <AddSubClient />,
    isProtected: true,
  },
  {
    path: "/client-management/view-client/:id",
    element: <ViewClient />,
    isProtected: true,
  },
  {
    path: "/client-management/view-subclient/:id",
    element: <ViewSubClient />,
    isProtected: true,
  },
  {
    path: "/client-management/edit-client/edit-subclient/:id",
    element: <EditSubClient />,
    isProtected: true,
  },

  // Employee / Team
  { path: "/team-management", element: <TeamManagement />, isProtected: true },
  {
    path: "/team-management/add-employee",
    element: <AddEmployee />,
    isProtected: true,
  },
  // { path: "/team-management/view-employee/:id", element: <ViewEmployee />, isProtected: true },
  {
    path: "/team-management/edit-employee/:id",
    element: <EditEmployee />,
    isProtected: true,
  },
  // { path: "/team-management/create-team-member", element: <CreateTeamMember />, isProtected: true },
  {
    path: "/team-management/profile/:id",
    element: <ViewEmployee />,
    isProtected: true,
  },
  {
    path: "/team-management/member-task",
    element: <MemberTask />,
    isProtected: true,
  },
  {
    path: "/team-management/member-task/view",
    element: <ViewTask />,
    isProtected: true,
  },

  // Tasks
  { path: "/task-management", element: <TaskManagement />, isProtected: true },
  {
    path: "/task-management/client-task",
    element: <AddTaskClient />,
    isProtected: true,
  },
  {
    path: "/task-management/view-client/create-task",
    element: <CreateTask />,
    isProtected: true,
  },
  {
    path: "/task-management/view-client",
    element: <ViewClientTask />,
    isProtected: true,
  },
  {
    path: "/task-management/view-client/tasks",
    element: <ViewTask />,
    isProtected: true,
  },

  // Calendar
  { path: "/calendar", element: <Calendar />, isProtected: true },
  {
    path: "/calendar/add-event",
    element: <AddCalendarEvent />,
    isProtected: true,
  },
  { path: "/calendar/:id", element: <EditCalendarEvent />, isProtected: true },

  // Information
  { path: "/info", element: <Information />, isProtected: true },

  // Compliances and Events
  {
    path: "/compliances",
    element: <CompliancesAndEvents />,
    isProtected: true,
  },

  // Notifications
  { path: "/notifications", element: <Notifications />, isProtected: true },
{
  path: "/notifications/edit-notification/:id", // Add 'edit-notification' here
  element: <EditNotification />,
  isProtected: true,
},
  {
    path: "/notifications/add-notification",
    element: <CreateNotification />,
    isProtected: true,
  },
  {
    path: "/notifications/add-alert",
    element: <CreateAlert />,
    isProtected: true,
  },

  // Services
  { path: "/services", element: <ServiceManagement />, isProtected: true },
  { path: "/services/add-service", element: <AddService />, isProtected: true },
  {
    path: "/services/view-service/:id",
    element: <ViewService />,
    isProtected: true,
  },

  //Enquires
  { path: "/enquires", element: <Enquires />, isProtected: true },
  {
    path: "/enquires/add-enquiry",
    element: <AddEnquires />,
    isProtected: true,
  },
 {
    path: "/enquires/view-enquiry/:id",
    element: <ViewEnquires />,
    isProtected: true,
  },

  // Mail, Reports, Settings
{ path: "/mails", element: <Mail />, isProtected: true },
{ path: "/mails/mail-details/:mailId", element: <MailDetailsWrapper />, isProtected: true },
  { path: "/reports", element: <Reports />, isProtected: true },
  {
    path: "/reports/client-details/:id",
    element: <ClientReport />,
    isProtected: true,
  },
  {
    path: "/reports/view-task/:id",
    element: <ViewReportTaskPage />,
    isProtected: true,
  },
  { path: "/settings", element: <Settings />, isProtected: true },

  // 404 fallback
  { path: "/*", element: <NotFoundPage />, isProtected: false },
];

export default routes;
